// components/layout/Footer.jsx
import React from 'react';
import { Icon } from '../ui/Icon';
import { useBrand } from '../../contexts/BrandContext';

export function Footer() {
  const { brand } = useBrand();
  
  return (
    <footer style={{ 
      background: brand.c.headerBg, 
      padding: '48px 24px 32px', 
      marginTop: 80,
      color: 'rgba(255,255,255,0.7)'
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ 
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: 40,
          marginBottom: 40
        }}>
          {/* Brand Section */}
          <div>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 12,
              marginBottom: 16
            }}>
              <div style={{
                width: 36,
                height: 36,
                borderRadius: 6,
                background: brand.logo ? 'transparent' : brand.c.accent,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden'
              }}>
                {brand.logo ? (
                  <img src={brand.logo} alt={brand.name} style={{ width: 36, height: 36, objectFit: 'contain' }} />
                ) : (
                  <Icon name="shield" size={18} color="#fff" />
                )}
              </div>
              <span style={{ 
                fontSize: 18, 
                fontWeight: 900, 
                color: '#fff',
                fontFamily: "'Merriweather', serif"
              }}>
                {brand.name}
              </span>
            </div>
            <p style={{ fontSize: 13, lineHeight: 1.7, marginBottom: 16 }}>
              {brand.isB2B 
                ? 'Direct procurement platform for health systems. Manufacturer-to-provider supply chain powered by iRemedy + UPS Healthcare.'
                : 'Licensed pharmaceutical distribution across all 50 states. Powered by iRemedy Healthcare infrastructure.'
              }
            </p>
            <div style={{ display: 'flex', gap: 12 }}>
              <a href="#" style={{ 
                color: 'rgba(255,255,255,0.7)',
                transition: 'color 0.2s'
              }}>
                <Icon name="mail" size={20} />
              </a>
              <a href="#" style={{ 
                color: 'rgba(255,255,255,0.7)',
                transition: 'color 0.2s'
              }}>
                <Icon name="phone" size={20} />
              </a>
            </div>
          </div>
          
          {/* Product Links */}
          <div>
            <h4 style={{ 
              fontSize: 12, 
              fontWeight: 800,
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              color: '#fff',
              marginBottom: 16
            }}>
              Product
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {brand.isB2B ? (
                <>
                  <li style={{ marginBottom: 10 }}>
                    <a href="#" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: 14 }}>
                      Catalog
                    </a>
                  </li>
                  <li style={{ marginBottom: 10 }}>
                    <a href="#" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: 14 }}>
                      Vendor Connections
                    </a>
                  </li>
                  <li style={{ marginBottom: 10 }}>
                    <a href="#" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: 14 }}>
                      Spend Analysis
                    </a>
                  </li>
                  <li style={{ marginBottom: 10 }}>
                    <a href="#" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: 14 }}>
                      Purchase Orders
                    </a>
                  </li>
                </>
              ) : (
                <>
                  <li style={{ marginBottom: 10 }}>
                    <a href="#" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: 14 }}>
                      How It Works
                    </a>
                  </li>
                  <li style={{ marginBottom: 10 }}>
                    <a href="#" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: 14 }}>
                      Pricing
                    </a>
                  </li>
                  <li style={{ marginBottom: 10 }}>
                    <a href="#" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: 14 }}>
                      Medications
                    </a>
                  </li>
                  <li style={{ marginBottom: 10 }}>
                    <a href="#" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: 14 }}>
                      Pilot Program
                    </a>
                  </li>
                </>
              )}
            </ul>
          </div>
          
          {/* Company Links */}
          <div>
            <h4 style={{ 
              fontSize: 12, 
              fontWeight: 800,
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              color: '#fff',
              marginBottom: 16
            }}>
              Company
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: 10 }}>
                <a href="#" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: 14 }}>
                  About Us
                </a>
              </li>
              <li style={{ marginBottom: 10 }}>
                <a href="#" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: 14 }}>
                  Careers
                </a>
              </li>
              <li style={{ marginBottom: 10 }}>
                <a href="#" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: 14 }}>
                  Press
                </a>
              </li>
              <li style={{ marginBottom: 10 }}>
                <a href="#" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: 14 }}>
                  Contact
                </a>
              </li>
            </ul>
          </div>
          
          {/* Legal Links */}
          <div>
            <h4 style={{ 
              fontSize: 12, 
              fontWeight: 800,
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              color: '#fff',
              marginBottom: 16
            }}>
              Legal
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: 10 }}>
                <a href="#" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: 14 }}>
                  Privacy Policy
                </a>
              </li>
              <li style={{ marginBottom: 10 }}>
                <a href="#" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: 14 }}>
                  Terms of Service
                </a>
              </li>
              <li style={{ marginBottom: 10 }}>
                <a href="#" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: 14 }}>
                  HIPAA Notice
                </a>
              </li>
              <li style={{ marginBottom: 10 }}>
                <a href="#" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: 14 }}>
                  Licenses
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div style={{ 
          borderTop: '1px solid rgba(255,255,255,0.1)',
          paddingTop: 24,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 16
        }}>
          <p style={{ fontSize: 13, margin: 0 }}>
            © {new Date().getFullYear()} {brand.name}. All rights reserved.
          </p>
          <div style={{ 
            display: 'flex', 
            gap: 16,
            fontSize: 11,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            fontWeight: 600
          }}>
            <span>🛡️ HIPAA Compliant</span>
            <span>🔒 DEA Licensed</span>
            <span>📦 DSCSA Tracked</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
